"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FeedbackField = require("./FeedbackField");
Object.keys(_FeedbackField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeedbackField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeedbackField[key];
    }
  });
});
